var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6438 7.14816L0.984976 7.14872C0.6707 7.14861 0.416016 6.88029 0.416016 6.54927C0.416016 6.21828 0.6707 5.94992 0.984976 5.94985L13.6412 5.94992L9.6536 1.74887C9.43145 1.51479 9.43145 1.13533 9.6536 0.901282C9.87578 0.667201 10.236 0.667201 10.4583 0.901282L15.417 6.12542C15.5278 6.24289 15.5839 6.39636 15.5839 6.54968C15.5839 6.64842 15.5609 6.7472 15.5149 6.83613C15.4891 6.88644 15.456 6.93367 15.4155 6.97607L10.4583 12.1997C10.236 12.4337 9.87578 12.4337 9.6536 12.1997C9.43145 11.9656 9.43145 11.5861 9.6536 11.3519L13.6438 7.14816Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3f1444301bc6b5060f7b6245c794b5b0.svg";
export { ForwardRef as ReactComponent };